import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { RettighedsType } from '../auth/rettighed.model';
import { NavigationModel } from './navigation.model';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  authService = inject(AuthService);

  getMenuItems() {
    return this.navigationItems.filter(x => {
      if (x.rettighed) {
        return this.authService.hasRettighed(x.rettighed);
      }
      return true;
    });
  }

  private navigationItems: NavigationModel[] = [
    {
      label: 'Dokumenter',
      routerLink: '/dokumenter',
      rettighed: RettighedsType.AdminDokumenter,
      items: [
        {
          label: 'Dokumenter',
          routerLink: '/dokumenter/dokumenter',
          rettighed: RettighedsType.AdminDokumenter,
        },
        {
          label: 'Afsendelse',
          routerLink: '/dokumenter/afsendelse',
          rettighed: RettighedsType.AdminDokumenter,
        },
      ],
    },
    {
      label: 'Pengeinstitutter',
      routerLink: '/pengeinstitutter',
      rettighed: RettighedsType.AdminPengeinstitutter,
    },
    {
      label: 'Kunder',
      routerLink: '/kunder',
      rettighed: RettighedsType.AdminKunder,
    },
    {
      label: 'Rådgivere',
      routerLink: '/raadgivere',
      rettighed: RettighedsType.AdminRaadgivere,
    },
    {
      label: 'Pensionsudbydere',
      routerLink: '/pensionsudbydere',
      rettighed: RettighedsType.AdminPensionsudbydere,
    },
    {
      label: 'Letregister',
      routerLink: '/letregister',
      rettighed: RettighedsType.AdminLetregister,
    },
    {
      label: 'Opkrævningslister',
      routerLink: '/opkraevningslister',
      rettighed: RettighedsType.AdminOpkraevningslister,
    },
    {
      label: 'Produktlister',
      routerLink: '/produktlister',
      rettighed: RettighedsType.AdminProduktlister,
    },
    {
      label: 'Risikoopkrævning',
      routerLink: '/risikoopkraevning',
      rettighed: RettighedsType.AdminRisikoopkraevning,
      items: [
        {
          label: 'Opkrævninger',
          routerLink: '/risikoopkraevning/opkraevninger',
          rettighed: RettighedsType.AdminRisikoopkraevning,
        },
        {
          label: 'Udestående',
          routerLink: '/risikoopkraevning/udestaaende',
          rettighed: RettighedsType.AdminRisikoopkraevning,
        },
        {
          label: 'Leverandør',
          routerLink: '/risikoopkraevning/leverandoer',
          rettighed: RettighedsType.AdminRisikoopkraevning,
        },
      ],
    },
    {
      label: 'Batch',
      routerLink: '/batch',
      rettighed: RettighedsType.AdminBatch,
    },
    {
      label: 'Log',
      routerLink: '/log',
      rettighed: RettighedsType.AdminLog,
    },
    {
      label: 'Driftsmeddelelser',
      routerLink: '/driftsmeddelelser',
      rettighed: RettighedsType.AdminDriftsmeddelelser,
    },
    {
      label: 'SSB Konfiguration',
      routerLink: '/ssbkonfiguration',
      rettighed: RettighedsType.AdminSsbKonfiguration,
    },
    {
      label: 'Filer',
      routerLink: '/filer',
      rettighed: RettighedsType.AdminFiler,
    },
    {
      label: 'Brugeradministration',
      routerLink: '/brugeradm',
      rettighed: RettighedsType.AdminBruger,
      items: [
        {
          label: 'Brugere',
          routerLink: '/brugeradm/brugere',
          rettighed: RettighedsType.AdminBruger,
        },
        {
          label: 'Roller',
          routerLink: '/brugeradm/roller',
          rettighed: RettighedsType.AdminRolle,
        },
      ],
    },
    {
      label: 'Forretningssupport',
      rettighed: RettighedsType.AdminSupportSletRevision,
      routerLink: '/support',
      items: [
        {
          label: 'Slet revision',
          routerLink: '/support/sletrevision',
          rettighed: RettighedsType.AdminSupportSletRevision,
        },
        {
          label: 'Vend til fysisk underskrift',
          routerLink: '/support/vendtilfysiskunderskrift',
          rettighed: RettighedsType.AdminSupportVendTilFysiskUnderskrift,
        },
      ],
    },
    {
      label: 'Letpension.dk',
      routerLink: '/letpensiondk',
      rettighed: RettighedsType.AdminLetpensionDk,
      items: [
        {
          label: 'Dokumenter',
          routerLink: '/letpensiondk/dokumenter',
          rettighed: RettighedsType.AdminLetpensionDk,
        },
        {
          label: 'Jobopslag',
          routerLink: '/letpensiondk/jobopslag',
          rettighed: RettighedsType.AdminLetpensionDk,
        },
        {
          label: 'Medarbejdere',
          routerLink: '/letpensiondk/medarbejdere',
          rettighed: RettighedsType.AdminLetpensionDk,
        },
        {
          label: 'Bestyrelse',
          routerLink: '/letpensiondk/bestyrelse',
          rettighed: RettighedsType.AdminLetpensionDk,
        },
      ],
    },
    {
      label: 'Visual guide',
      routerLink: '/visualguide',
      rettighed: RettighedsType.DeveloperMode,
    },
    {
      label: 'Test page',
      routerLink: '/test',
      rettighed: RettighedsType.DeveloperMode,
    },
  ];

  getProfileMenuItems(): NavigationModel[] {
    return [
      {
        icon: 'pi pi-user',
        label: 'Profil',
        routerLink: '/profile',
      },
    ];
  }
}
